import * as React from "react";
import {useEffect, useState} from "react";
import AceEditor from "react-ace";
import {EncodingSelector} from "../../main/pages/docViewer/EncodingSelector";
import {fileTypeByFileName} from "./FileViewer";


export function TextFileViewer({buffer, fileName}) {
    const [encoding, setEncoding] = useState('utf-8')
    const [fileText, setFileText] = useState('')
    const [fileType, setFileType] = useState('json')

    useEffect(() => {
        setFileType(fileTypeByFileName(fileName))
        setFileText(readFileContent())
    }, [buffer])

    function readFileContent() {
        if (buffer) {
            console.log('Reading file content with encoding', encoding)
            let decoder = new TextDecoder(encoding);
            return beautify(decoder.decode(buffer))
        }
        return ""
    }

    function beautify(uglyText: string) {
        let fileEnding = fileName.toLowerCase().split('.').pop()
        if (fileEnding === 'json') {
            return JSON.stringify(JSON.parse(uglyText), null, 2)
        }
        if (fileEnding === 'xml') {
            console.log("Beautifying XML")
            try {
                const xmlFormatter = require('xml-formatter');
                return xmlFormatter(uglyText)
            } catch (e) {
                console.error('Error beautifying XML', e)
            }
        }
        return uglyText

    }

    return <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
        <div style={{flex: 1, position: 'relative'}}>
            <AceEditor
                theme="monokai"
                style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0}}
                mode={fileType}
                value={fileText}
                placeholder={'Nothing found'}
                width="100%"
                height="100%"
                readOnly={true}
            />
        </div>
        <EncodingSelector
            encoding={encoding}
            onChange={(encoding) => {
                setEncoding(encoding)
            }}
        />
    </div>
}

function readFileContent(): React.SetStateAction<string> {
    throw new Error("Function not implemented.");
}
